import { render, staticRenderFns } from "./SessionTimout.vue?vue&type=template&id=712cf172&"
import script from "./SessionTimout.vue?vue&type=script&lang=ts&"
export * from "./SessionTimout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports